<div class="question-container container section-gap">
  <div class="question">
    <div class="row">
      <div *ngIf="imageObject" class="col-lg-6 col-sm-4 col-12 row align-items-center m-auto" >
        <div class="overlay-wrap">
          <kla-image-object [imageObject]="imageObject" [imageClass]="'image'"></kla-image-object>
        </div>
      </div>
      <div class="col-lg-6 col-sm-8 col-12">
        <div class="question-description-container">
          <app-badges [badges]="config.badges"></app-badges>
          <div class="d-flex align-items-center">
            <h4 [id]="config.question | stripSpecialChars">{{config.question}}</h4>
            <kla-social-media-buttons class="mb-2" [linkFragment]="config.question"></kla-social-media-buttons>
          </div>
          <app-dynamic-content
            [contentId]="'question-desc'"
            [htmlContent]="config.description">
          </app-dynamic-content>
          <kla-button [title]="config.button"
                      addPadding="0px 20px 0px 20px"
                      [borderColor]="config?.buttonColor"
                      [configLink]="config?.link"
                      [class]="'config-link-button'"
                      *ngIf="isLinkVisible">
          </kla-button>
        </div>
      </div>
    </div>
  </div>
</div>
